/** LaunchDarkly boolean flags — when true, the nav item and route are hidden. */

export const HIDE_DASHBOARD_FLAG = "hide-dashboard";
export const HIDE_TICKETS_FLAG = "hide-tickets";
export const HIDE_FFID_FLAG = "hide-ffid";
export const HIDE_TRIGGER_WORKFLOW_FLAG = "hide-trigger-workflow";
export const HIDE_AGENT_STUDIO_FLAG = "hide-agent-studio";
export const HIDE_VIBE_CODING_STUDIO_FLAG = "hide-vibe-coding-studio";
export const HIDE_DISCOVERY_FLAG = "hide-discovery";
export const HIDE_DEPLOYMENT_STUDIO_FLAG = "hide-deployment-studio";
export const HIDE_ERROR_RESOLUTION_FLAG = "hide-error-resolution";
export const HIDE_APPROVALS_FLAG = "hide-approvals";
export const HIDE_ANALYTICS_FLAG = "hide-analytics";
export const HIDE_BUSINESS_VALUE_FLAG = "hide-business-value";
export const HIDE_REPORTS_FLAG = "hide-reports";
export const HIDE_DOCUMENTATION_FLAG = "hide-documentation";
export const HIDE_SETTINGS_FLAG = "hide-settings";
export const HIDE_SOD_RULES_FLAG = "hide-sod-rules";
export const HIDE_INFO_ASSISTANT_FLAG = "hide-info-assistant";
export const HIDE_AURA_FLAG = "hide-aura";
export const HIDE_ABAP_TRANSPORTS_FLAG = "hide-abap-transports";

export const ALL_NAV_HIDE_FLAGS = [
  HIDE_DASHBOARD_FLAG,
  HIDE_TICKETS_FLAG,
  HIDE_FFID_FLAG,
  HIDE_TRIGGER_WORKFLOW_FLAG,
  HIDE_AGENT_STUDIO_FLAG,
  HIDE_VIBE_CODING_STUDIO_FLAG,
  HIDE_DISCOVERY_FLAG,
  HIDE_DEPLOYMENT_STUDIO_FLAG,
  HIDE_ERROR_RESOLUTION_FLAG,
  HIDE_APPROVALS_FLAG,
  HIDE_ANALYTICS_FLAG,
  HIDE_BUSINESS_VALUE_FLAG,
  HIDE_REPORTS_FLAG,
  HIDE_DOCUMENTATION_FLAG,
  HIDE_SETTINGS_FLAG,
  HIDE_SOD_RULES_FLAG,
  HIDE_INFO_ASSISTANT_FLAG,
  HIDE_AURA_FLAG,
  HIDE_ABAP_TRANSPORTS_FLAG,
];

/** @type {Record<string, boolean>} */
export const DEFAULT_HIDDEN_FLAGS = Object.fromEntries(
  ALL_NAV_HIDE_FLAGS.map((flag) => [flag, false]),
);

/**
 * Route → hide flag. First matching rule wins.
 * @type {Array<{ match: (path: string) => boolean, flag: string }>}
 */
export const ROUTE_FLAG_RULES = [
  { match: (p) => p === "/", flag: HIDE_DASHBOARD_FLAG },
  {
    match: (p) =>
      p === "/tickets" || p.startsWith("/tickets/") || p.startsWith("/tickets-old/"),
    flag: HIDE_TICKETS_FLAG,
  },
  {
    match: (p) => p === "/ffid" || p.startsWith("/ffid/"),
    flag: HIDE_FFID_FLAG,
  },
  {
    match: (p) => p === "/trigger-workflow" || p.startsWith("/trigger-workflow/"),
    flag: HIDE_TRIGGER_WORKFLOW_FLAG,
  },
  {
    match: (p) => p === "/agent-studio" || p.startsWith("/agent-studio/"),
    flag: HIDE_AGENT_STUDIO_FLAG,
  },
  {
    match: (p) => p === "/workflow-templates" || p.startsWith("/workflow-templates/"),
    flag: HIDE_AGENT_STUDIO_FLAG,
  },
  {
    match: (p) => p.startsWith("/vibe-studio"),
    flag: HIDE_VIBE_CODING_STUDIO_FLAG,
  },
  { match: (p) => p === "/discovery" || p.startsWith("/discovery/"), flag: HIDE_DISCOVERY_FLAG },
  {
    match: (p) => p === "/deployment" || p.startsWith("/deployment/"),
    flag: HIDE_DEPLOYMENT_STUDIO_FLAG,
  },
  { match: (p) => p === "/errors" || p.startsWith("/errors/"), flag: HIDE_ERROR_RESOLUTION_FLAG },
  {
    match: (p) => p === "/approvals" || p.startsWith("/approvals/"),
    flag: HIDE_APPROVALS_FLAG,
  },
  { match: (p) => p === "/analytics" || p.startsWith("/analytics/"), flag: HIDE_ANALYTICS_FLAG },
  {
    match: (p) => p === "/business-value" || p.startsWith("/business-value/"),
    flag: HIDE_BUSINESS_VALUE_FLAG,
  },
  { match: (p) => p === "/reports" || p.startsWith("/reports/"), flag: HIDE_REPORTS_FLAG },
  {
    match: (p) => p === "/documentation" || p.startsWith("/documentation/"),
    flag: HIDE_DOCUMENTATION_FLAG,
  },
  { match: (p) => p === "/settings" || p.startsWith("/settings/"), flag: HIDE_SETTINGS_FLAG },
  { match: (p) => p === "/sod-rules" || p.startsWith("/sod-rules/"), flag: HIDE_SOD_RULES_FLAG },
  {
    match: (p) =>
      p === "/transformations"
      || p.startsWith("/transformations/")
      || p === "/aura"
      || p.startsWith("/aura/"),
    flag: HIDE_AURA_FLAG,
  },
  {
    match: (p) => p === "/abap-transports" || p.startsWith("/abap-transports/"),
    flag: HIDE_ABAP_TRANSPORTS_FLAG,
  },
];

/**
 * @param {string} pathname
 * @returns {string | null}
 */
export function featureFlagForPath(pathname) {
  const path = pathname.split("?")[0];
  for (const rule of ROUTE_FLAG_RULES) {
    if (rule.match(path)) {
      return rule.flag;
    }
  }
  return null;
}

/**
 * @param {string | undefined} featureFlag
 * @param {Record<string, boolean>} hiddenFlags
 */
export function isNavItemVisibleByFlags(featureFlag, hiddenFlags) {
  if (!featureFlag) {
    return true;
  }
  return hiddenFlags[featureFlag] !== true;
}

/**
 * @param {string} pathname
 * @param {Record<string, boolean>} hiddenFlags
 */
export function isPathVisibleByFlags(pathname, hiddenFlags) {
  const flag = featureFlagForPath(pathname);
  if (!flag) {
    return true;
  }
  return hiddenFlags[flag] !== true;
}
